import { useRef } from "react";

function useRendersCount(componentName) {
  const renders = useRef(1);
  console.log(`${componentName} renders count: ${renders.current++}`);
}

export default useRendersCount;
